module.exports = __webpack_public_path__ + "img/step9.98f27dd8.png";